var _mask, _path, _mask2, _path2, _mask3, _path3, _line, _line2, _line3, _line4, _mask4, _path4, _mask5, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetodologyRadarCrgci(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 364,
    viewBox: "0 0 364 364",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_1818_12286",
    maskUnits: "userSpaceOnUse",
    x: 90.002,
    y: 90,
    width: 184,
    height: 184,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 90.002,
    y: 90,
    width: 184,
    height: 184
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.002 182C272.002 199.8 266.723 217.201 256.834 232.001C246.945 246.802 232.889 258.337 216.443 265.149C199.998 271.961 181.902 273.743 164.444 270.271C146.985 266.798 130.949 258.226 118.362 245.639C105.776 233.053 97.2039 217.016 93.7313 199.558C90.2586 182.1 92.0409 164.004 98.8528 147.558C105.665 131.113 117.2 117.057 132.001 107.168C146.801 97.2784 164.202 92 182.002 92V182H272.002Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272.002 182C272.002 199.8 266.723 217.201 256.834 232.001C246.945 246.802 232.889 258.337 216.443 265.149C199.998 271.961 181.902 273.743 164.444 270.271C146.985 266.798 130.949 258.226 118.362 245.639C105.776 233.053 97.2039 217.016 93.7313 199.558C90.2586 182.1 92.0409 164.004 98.8528 147.558C105.665 131.113 117.2 117.057 132.001 107.168C146.801 97.2784 164.202 92 182.002 92V182H272.002Z",
    stroke: "#585F81",
    strokeWidth: 3.6,
    mask: "url(#path-1-outside-1_1818_12286)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-2_1818_12286",
    maskUnits: "userSpaceOnUse",
    x: 45.0017,
    y: 45,
    width: 274,
    height: 274,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 45.0017,
    y: 45,
    width: 274,
    height: 274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.001 182C317.001 208.7 309.084 234.801 294.25 257.002C279.416 279.202 258.332 296.506 233.664 306.724C208.996 316.941 181.852 319.615 155.664 314.406C129.477 309.197 105.422 296.339 86.5423 277.459C67.6622 258.579 54.8047 234.524 49.5957 208.337C44.3867 182.15 47.0601 155.006 57.278 130.338C67.4958 105.67 84.7991 84.5856 107 69.7516C129.2 54.9176 155.301 47 182.002 47V182H317.001Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M317.001 182C317.001 208.7 309.084 234.801 294.25 257.002C279.416 279.202 258.332 296.506 233.664 306.724C208.996 316.941 181.852 319.615 155.664 314.406C129.477 309.197 105.422 296.339 86.5423 277.459C67.6622 258.579 54.8047 234.524 49.5957 208.337C44.3867 182.15 47.0601 155.006 57.278 130.338C67.4958 105.67 84.7991 84.5856 107 69.7516C129.2 54.9176 155.301 47 182.002 47V182H317.001Z",
    stroke: "#585F81",
    strokeWidth: 3.6,
    mask: "url(#path-2-outside-2_1818_12286)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-3_1818_12286",
    maskUnits: "userSpaceOnUse",
    x: 0.00195312,
    y: 0,
    width: 364,
    height: 364,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.00195312,
    width: 364,
    height: 364
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.002 182C362.002 217.6 351.445 252.402 331.666 282.002C311.888 311.603 283.775 334.674 250.885 348.298C217.994 361.922 181.802 365.486 146.886 358.541C111.969 351.596 79.8961 334.452 54.7227 309.279C29.5493 284.106 12.4059 252.033 5.4606 217.116C-1.48473 182.2 2.07986 146.008 15.7036 113.117C29.3274 80.2262 52.3984 52.1141 81.9992 32.3354C111.6 12.5568 146.401 2 182.002 2V182H362.002Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M362.002 182C362.002 217.6 351.445 252.402 331.666 282.002C311.888 311.603 283.775 334.674 250.885 348.298C217.994 361.922 181.802 365.486 146.886 358.541C111.969 351.596 79.8961 334.452 54.7227 309.279C29.5493 284.106 12.4059 252.033 5.4606 217.116C-1.48473 182.2 2.07986 146.008 15.7036 113.117C29.3274 80.2262 52.3984 52.1141 81.9992 32.3354C111.6 12.5568 146.401 2 182.002 2V182H362.002Z",
    stroke: "#585F81",
    strokeWidth: 3.6,
    mask: "url(#path-3-outside-3_1818_12286)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 182.9,
    y1: 2,
    x2: 182.9,
    y2: 362,
    stroke: "#585F81",
    strokeWidth: 1.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 182.257,
    y1: 183.015,
    x2: 55.3576,
    y2: 309.915,
    stroke: "#585F81",
    strokeWidth: 1.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 55.3571,
    y1: 54.0843,
    x2: 309.915,
    y2: 308.643,
    stroke: "#585F81",
    strokeWidth: 1.8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 181.1,
    x2: 182,
    y2: 181.1,
    stroke: "#585F81",
    strokeWidth: 1.8
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-4_1818_12286",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.002 182C227.002 190.9 224.363 199.6 219.418 207.001C214.473 214.401 207.445 220.169 199.223 223.575C191 226.98 181.952 227.872 173.223 226.135C164.494 224.399 156.475 220.113 150.182 213.82C143.889 207.526 139.603 199.508 137.867 190.779C136.13 182.05 137.021 173.002 140.427 164.779C143.833 156.557 149.601 149.529 157.001 144.584C164.401 139.639 173.102 137 182.002 137V182H227.002Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.002 182C227.002 190.9 224.363 199.6 219.418 207.001C214.473 214.401 207.445 220.169 199.223 223.575C191 226.98 181.952 227.872 173.223 226.135C164.494 224.399 156.475 220.113 150.182 213.82C143.889 207.526 139.603 199.508 137.867 190.779C136.13 182.05 137.021 173.002 140.427 164.779C143.833 156.557 149.601 149.529 157.001 144.584C164.401 139.639 173.102 137 182.002 137V182H227.002Z",
    fill: "#22272B",
    stroke: "#585F81",
    strokeWidth: 3.6,
    mask: "url(#path-8-inside-4_1818_12286)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-outside-5_1818_12286",
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 0,
    width: 184,
    height: 184,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 180,
    width: 184,
    height: 184
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 2C205.638 2 229.044 6.65584 250.883 15.7017C272.721 24.7475 292.564 38.0062 309.279 54.7207C325.993 71.4353 339.252 91.2783 348.298 113.117C357.344 134.956 362 158.362 362 182L182 182V2Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M182 2C205.638 2 229.044 6.65584 250.883 15.7017C272.721 24.7475 292.564 38.0062 309.279 54.7207C325.993 71.4353 339.252 91.2783 348.298 113.117C357.344 134.956 362 158.362 362 182L182 182V2Z",
    fill: "#11A0DA",
    fillOpacity: 0.33
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M182 2C205.638 2 229.044 6.65584 250.883 15.7017C272.721 24.7475 292.564 38.0062 309.279 54.7207C325.993 71.4353 339.252 91.2783 348.298 113.117C357.344 134.956 362 158.362 362 182L182 182V2Z",
    stroke: "#11A0DA",
    strokeWidth: 3.6,
    mask: "url(#path-9-outside-5_1818_12286)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetodologyRadarCrgci);
export default __webpack_public_path__ + "static/media/metodology-radar-crgci.a4662e2d2df057755989f365191d8e71.svg";
export { ForwardRef as ReactComponent };